import { useMemo } from 'react';
import type { ConsistencyLinkCollection } from '@view-model/domain/ConsistencyLink/ConsistencyLinkCollection';
import { ConsistencyLinkView } from './ConsistencyLinkView';
import type { ViewCollectionContents } from '@view-model/domain/view/ViewCollectionContents';
import type { ConsistencyLinkId } from 'balus-common';

type Props = {
  viewContents: ViewCollectionContents;
  selectedIds: Set<ConsistencyLinkId>;
  onSelect(id: string | null): void;
  consistencyLinks: ConsistencyLinkCollection | null;
};

export const ConsistencyLinkCollectionView: React.FC<Props> = ({
  viewContents,
  selectedIds,
  onSelect,
  consistencyLinks,
}: Props) => {
  // 整合性リンクの両端のViewが存在するものに絞り込む
  const validLinks = useMemo(
    () => consistencyLinks?.validLinksBy(viewContents.getViews()) ?? false,
    [consistencyLinks, viewContents]
  );

  // 描画するべきリンクが無い場合には早期return
  if (!validLinks) return null;

  return (
    <g>
      {validLinks.map((consistencyLink) => (
        <ConsistencyLinkView
          key={consistencyLink.id}
          consistencyLink={consistencyLink}
          isSelected={selectedIds.has(consistencyLink.id)}
          onSelectConsistencyLink={onSelect}
          viewContents={viewContents}
        />
      ))}
    </g>
  );
};
